<template>
  <div class="overtimeRules">
    <Header headerTitle="无法停止充电"></Header>
    <div class="main-container" style="padding-top:10px;">
      <!-- section -->
      <section>
        <div class="cardAddress">
          <div>停止码: {{ identCode && identCode != 'null' && identCode != 'undefined' ? identCode : '' }}</div>
        </div>
      </section>
      <!-- footer -->
    </div>
  </div>
</template>
<script>
import { timeOutPricingDetails } from "@/api/public.js";
export default {
  name: "OvertimeRules",
  data() {
    return {
      overTimeList: {},
      message: "", //提示信息
      tipShow: "0", //是否提示
      tipType: "", //提示类型
      equipmentTip: '设备已准备就绪，请启动充电',
      chargeBtnTitle: '启动充电',
      noticeTitle: '',
      noticeInfo: '',
      chargeInterval: undefined,
      identCode: ''
    };
  },
  created() {
    this.identCode = this.$route.params.identCode;
  },
  destroyed() {
    if (this.chargeInterval != null) {
      clearInterval(this.chargeInterval);
    }
  },
  methods: {
    noticeStartCharge() {
      this.noticeTitle = '确定启动充电？'
      this.noticeInfo = '充电前，请先熄火，电动汽车需要在熄火的状态下进行充电，建议同时关闭车内电源'
      this.$refs["notice-start-charge"].show();
    },
    handleCharge() {
      this.startCharge()
    },
    startCharge() {
      this.noticeTitle = '温馨提示'
      this.noticeInfo = '90s'
      this.$refs["notice-charge-tip"].show();

      this.chargeInterval = setInterval(function () {
        //
      }, 5000);
    },
    //加载数据
    loadOverTimeList: function() {
      timeOutPricingDetails({}).then(
          response => {
            if (response.data.status == 200) {
            } else {
              this.tipShow = "1" + Math.random() * 1000;
              this.message = response.data.message;
              this.tipType = "warning";
            }
          },
          err => {
            reject(err);
          }
      );
    }
  },
  mounted() {
    this.loadOverTimeList();
  }
};
</script>
<style>
.overtimeRules, .main-container {
  height: calc(100% - 50px);
}
.overtimeRules section {
  width: 100%;
  height: 65%;
  padding: 10px;
}

.overtimeRules section .row {
  padding: 0 15px;
}
.overtimeRules section .row .col-12 {
  background-color: #f1f1f1;
  justify-content: center;
  margin-bottom: 3px;
  line-height: 70px;
}
.overtimeRules section .row .col-4 {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f1f1f1;
  height: 100px;
  margin-bottom: 3px;
  font-size: 0.98rem;
  padding: 0;
  text-align: center;
}
.overtimeRules section .row .col-8{
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f1f1f1;
  height: 100px;
  margin-bottom: 3px;
  text-align: left;
  margin-left: 5px;
  max-width: 65%;
}
</style>


